import React, { useEffect, useState } from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";
import Snack from "@material-ui/core/Snackbar";
import IconButton from "@material-ui/core/IconButton";
// @material-ui/icons
import Close from "@material-ui/icons/Close";
import { useAlert } from "../../../src/context/Feedback/alertContext";

// core components
import styles from "assets/jss/material-dashboard-react/components/snackbarContentStyle.js";

const useStyles = makeStyles(styles);

export default function Snackbar(props) {
  const classes = useStyles();
  const { message, color, close, icon, place, rtlActive } = props;
  const { feedbackAlert, setAlert } = useAlert();
  const [open, setOpen] = useState(false);
  const displayMessage = feedbackAlert.text || message;
  const displayColor = feedbackAlert.color || color || "info";
  const DisplayIcon = feedbackAlert.icon || icon;

  var action = [];
  const messageClasses = classNames({
    [classes.iconMessage]: DisplayIcon !== undefined,
  });
  useEffect(() => {
    if (feedbackAlert.active) {
      setOpen(true);
      const timer = setTimeout(() => {
        setOpen(false);
        setTimeout(() => {
          setAlert((prev) => ({
            ...prev,
            active: false,
          }));
        }, 150);
      }, feedbackAlert.duration || 2000);
      return () => clearTimeout(timer);
    } else {
      setOpen(false);
    }
  }, [feedbackAlert.active, feedbackAlert.duration, setAlert]);

  if (close !== undefined) {
    action = [
      <IconButton
        className={classes.iconButton}
        key="close"
        aria-label="Close"
        color="inherit"
        onClick={() => {
          setOpen(false);
          setAlert((prev) => ({ ...prev, active: false }));
          if (props.closeNotification) {
            props.closeNotification();
          }
        }}
      >
        <Close className={classes.close} />
      </IconButton>,
    ];
  }
  return (
    <Snack
      anchorOrigin={{
        vertical: place.indexOf("t") === -1 ? "bottom" : "top",
        horizontal:
          place.indexOf("l") !== -1
            ? "left"
            : place.indexOf("c") !== -1
              ? "center"
              : "right",
      }}
      open={open}
      message={
        <div>
          {DisplayIcon !== undefined ? (
            <DisplayIcon className={classes.icon} />
          ) : null}
          <span className={messageClasses}>{displayMessage}</span>
        </div>
      }
      action={action}
      ContentProps={{
        classes: {
          root: classes.root + " " + classes[displayColor],
          action: classNames({ [classes.actionRTL]: rtlActive }),
        },
      }}
    />
  );
}

Snackbar.propTypes = {
  message: PropTypes.node,
  color: PropTypes.oneOf(["info", "success", "warning", "danger", "primary"]),
  close: PropTypes.bool,
  icon: PropTypes.object,
  place: PropTypes.oneOf(["tl", "tr", "tc", "br", "bl", "bc"]),
  open: PropTypes.bool,
  rtlActive: PropTypes.bool,
  closeNotification: PropTypes.func,
};
